package com.eladfinish.bible.contest.screens.lexicographicalSort.usecases

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.data.common.AssetReader
import com.eladfinish.bible.contest.data.common.stringResolver.IStringResolver
import com.eladfinish.bible.contest.extensions.formatString
import com.eladfinish.bible.contest.lefi_mikud
import com.eladfinish.bible.contest.perek_str_hebrew
import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.OutputChapters
import com.eladfinish.bible.contest.screens.lexicographicalSort.model.LexicographicalTableLabels
import com.eladfinish.bible.contest.table_html
import com.eladfinish.bible.contest.utils.addGershaim
import com.eladfinish.bible.contest.utils.toOtiot
import dev.icerock.moko.resources.desc.desc

class SortLexicographicallyWebViewUseCase(
    private val assetReader: AssetReader,
    private val stringResolver: IStringResolver,
) {

    operator fun invoke(
        hebrewBookName: String,
        chapterNum: Int,
        data: String,
        outputChapters: OutputChapters,
        verseCount: Int = 0,
    ): String {
        val html = assetReader.readFile(SharedRes.assets.webview.table_html)

        val headerCell = """<th class="center small">%s</th>"""
        val speaker: String = speakerTitle(hebrewBookName)?.let { headerCell.formatString(it) }.orEmpty()
        val output = html.formatString(place(hebrewBookName, chapterNum, outputChapters), speaker, data)
        if (verseCount <= 0) return output
        val subtitle = """<p class="verse-count">${LexicographicalTableLabels.verseCount(verseCount)}</p>"""
        return output.replace("</h3>", "</h3>\n$subtitle")
    }

    /** The book (and chapter / "by mikud") the table covers, as shown in its title. */
    fun place(hebrewBookName: String, chapterNum: Int, outputChapters: OutputChapters): String =
        hebrewBookName + when (outputChapters) {
            OutputChapters.SINGLE -> {
                " " + stringResolver.resolveString(SharedRes.strings.perek_str_hebrew.desc()) +
                        " " + chapterNum.toOtiot().addGershaim()
            }

            // TODO: write actual chapters
            OutputChapters.BY_MIKUD -> {
                " (${stringResolver.resolveString(SharedRes.strings.lefi_mikud.desc())})"
            }

            OutputChapters.ALL -> {
                ""
            }
        }

    /** Header of the extra column Tehilim and Iyov have; null for every other book. */
    fun speakerTitle(hebrewBookName: String): String? = when (hebrewBookName) {
        "תהילים" -> "משורר"
        "איוב" -> "דובר"
        else -> null
    }

}
